import React from 'react'
import Svg from '../../SvgComponent/Svg'
import { SvgProps } from '../../SvgComponent/types'

const Icon: React.FC<SvgProps> = (props) => {
  const { width, height } = props
  return (
    <Svg width={width || '24'} height={height || '24'} viewBox="0 0 24 24" fill="none" {...props}>
      <circle cx="12" cy="12" r="12" fill="#F6F6F6" />
      <path
        d="M11.9992 4.28516L11.8931 4.63676V14.8385L11.9992 14.9417L16.8542 12.1426L11.9992 4.28516Z"
        fill="#343434"
      />
      <path d="M11.9982 4.28516L7.14307 12.1426L11.9982 14.9417V9.99011V4.28516Z" fill="#8C8C8C" />
      <path
        d="M11.9993 15.8387L11.9395 15.9099V19.5439L11.9993 19.7142L16.8573 13.041L11.9993 15.8387Z"
        fill="#3C3C3B"
      />
      <path d="M11.9982 19.7142V15.8387L7.14307 13.041L11.9982 19.7142Z" fill="#8C8C8C" />
      <path d="M11.9976 14.9419L16.8526 12.1427L11.9976 9.99023V14.9419Z" fill="#141414" />
      <path d="M7.14307 12.1427L11.9982 14.9419V9.99023L7.14307 12.1427Z" fill="#393939" />
    </Svg>
  )
}

export default Icon
